import { Formik, FormikHelpers } from "formik";
import { WisaTabletFormInitValues } from "../../interfaces/fe.interfaces";
import styles from "./styles.module.scss";
import Form from "./Form";
import { http } from "../../api/utils/http";
import { getTablet, updateCertTablet } from "../../api/config";
import { useFetch } from "../../hooks/useFetch";
import { useState } from "react";
import { UpdateItemResponse, WisaTablet } from "../../interfaces/be.interfaces";
import moment from "moment";
import { validateWiSATablets } from "../../utils/validationSchemas";
import { toast } from "react-toastify";

const initialValues: WisaTabletFormInitValues = {
  it_tag: "",
  tablet_device_id: "",
  tablet_name: "",
  tablet_mfg: "",
  rssi: null,
  customer_checked_out_to: null,
  date_shipped: null,
  ship_to_tracking_id: null,
  ship_from_tracking_id: null,
  return_date: null,
  calibration_date: null,
};

interface EditCertTabletProps {
  onCancelClick: () => void;
  onSuccess: () => void;
  id: number | null;
}

const EditCertTablet = ({ onCancelClick, onSuccess, id }: EditCertTabletProps) => {
  const [initValues, setInitValues] = useState<WisaTabletFormInitValues>(initialValues);

  const handleSubmit = (data: WisaTabletFormInitValues, { setSubmitting }: FormikHelpers<WisaTabletFormInitValues>) => {
    http.makePostRequest<WisaTabletFormInitValues, { message: string }>(
      `${updateCertTablet}/${id}`,
      () => {
        onSuccess();
      },
      (error) => {
        setSubmitting(false);
        toast.error(error?.response?.data?.message);
      },
      data
    );
  };

  // Fetch current data of tablet
  useFetch<UpdateItemResponse<WisaTablet>>({
    url: `${getTablet}/${id}`,
    runOnMount: true,
    onSuccess: (response) => {
      // Save to initial values to show predefined values
      setInitValues({
        it_tag: response.data.data.it_tag,
        tablet_device_id: response.data.data.tablet_device_id,
        tablet_name: response.data.data.tablet_name,
        tablet_mfg: response.data.data.tablet_mfg,
        rssi: response.data.data.rssi,
        customer_checked_out_to: response.data.data.customer_checked_out_to,
        date_shipped: response.data.data.date_shipped ? moment(response.data.data.date_shipped).format("YYYY-MM-DD") : null,
        ship_to_tracking_id: response.data.data.ship_to_tracking_id,
        ship_from_tracking_id: response.data.data.ship_from_tracking_id,
        return_date: response.data.data.return_date ? moment(response.data.data.return_date).format("YYYY-MM-DD") : null,
        calibration_date: response.data.data.calibration_date ? moment(response.data.data.calibration_date).format("YYYY-MM-DD") : null,
      });
    },
  });

  return (
    <div className={styles.dialogContainer}>
      <Formik enableReinitialize initialValues={initValues} validationSchema={validateWiSATablets} onSubmit={handleSubmit}>
        {(props) => <Form {...props} editMode onCancelClick={onCancelClick} />}
      </Formik>
    </div>
  );
};

export default EditCertTablet;
